import React from "react";
import style from "../../Styles/Components/TapSelector.module.css";

const TapSelector = ({ taps, selectedTap, onClickTap }) => (
  <div className={style.container}>
    {taps &&
      taps.map((tapTitle, index) => (
        <div
          key={index}
          className={`${style.tap} ${selectedTap === index && style.selected}`}
          onClick={() => onClickTap(index)}
        >
          {tapTitle}
        </div>
      ))}
  </div>
);

export default TapSelector;
